// default income description templates for promoted broker payouts. the {name} placeholder is
// substituted with the instrument name (falling back to ticker). user-typed custom templates may
// contain anything; these are only the app's own defaults, kept in English.
export const DEFAULT_DIVIDEND_DESCRIPTION_TEMPLATE = 'Dividends {name}'
export const DEFAULT_COUPON_DESCRIPTION_TEMPLATE = 'Coupons {name}'

// T-Bank's default brokerage commission rate (0.04%). the single source of truth for the constant
// that was copy-pasted across the auto-buy bot, the day-trade backtest config, and the OFZ screener.
export const DEFAULT_TBANK_COMMISSION_RATE = 0.0004
